import styled from 'styled-components';
import { layout, media } from 'src/components/base';
import { PrimaryButton } from '@prisjakt/ui/button/variants';

export const ForumTopic = styled.div`
  display: flex;
  flex-direction: column;
  ${media.mediumUp`
      flex-direction: row;
   `}
`;

export const Topics = styled.div`
  display: grid;
  grid-gap: 10px;
  flex: 1;
  ${media.mediumUp`
  grid-template-columns: repeat(3, 30%);
   `}
`;

export const Forum = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  svg {
    fill: ${p => p.theme.colors.base300};
    margin-bottom: 1em;
  }
`;

export const StyledPrimaryButton = styled(PrimaryButton)`
  width: 100%;
  margin-top: ${layout.measurements.spacing100};
`;
